module.exports = __webpack_public_path__ + "img/logo.b085501b.png";